<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="pui">
        <div slot="toolbar">
          <el-button type="primary" @click="$refs.editPage.open(0)">
            新建
          </el-button>
          <!--          <el-button v-if="delAuth" type="danger" @click="deleteRows">批量删除</el-button>-->
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="编号">
              <el-input v-model.trim="filter.puiNo" clearable/>
            </vm-search>
            <vm-search label="申请类型">
              <el-select v-model.trim="filter.applyType" clearable placeholder="请选择">
                <el-option
                    v-for="item in constant.toSelect(constant.applyType)"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </vm-search>
            <vm-search label="产品名称">
              <el-input v-model.trim="filter.productName" clearable/>
            </vm-search>
            <vm-search label="产品型号">
              <el-input v-model.trim="filter.productModel" clearable/>
            </vm-search>
            <vm-search label="状态">
              <el-select v-model.trim="filter.status" clearable placeholder="请选择">
                <el-option
                    v-for="item in constant.toSelect(constant.puiStatus)"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </vm-search>
          </div>
        </template>
        <el-table-column prop="puiNo" width="110" align="center" label="编号">
          <template slot-scope="scope">
            <span style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.puiNo}}</span>
            <el-button
                v-clipboard="scope.row.puiNo"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                round
                icon="el-icon-chat-line-square"/>
          </template>
        </el-table-column>
        <el-table-column prop="applyType" align="center" label="申请类型">
          <template slot-scope="scope">
            {{constant.applyType[scope.row.applyType]}}
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" align="center" label="申请人"/>
        <el-table-column prop="productName" align="center" label="产品名称"/>
        <el-table-column prop="productModel" align="center" label="产品型号"/>
        <el-table-column prop="affectQuantity" align="center" label="影响数量"/>
        <el-table-column prop="productionDateAndBatch" align="center" label="批次和生产日期"/>
        <el-table-column prop="defectDesc" align="center" label="缺陷描述"/>
        <el-table-column prop="defectResult" align="center" label="缺陷可能导致的后果"/>
        <el-table-column prop="defectReason" align="center" label="生产缺陷的原因"/>
        <el-table-column prop="status" align="center" label="状态">
          <template slot-scope="scope">
            {{constant.puiStatus[scope.row.status]}}
          </template>
        </el-table-column>
        <!--        <el-table-column prop="creatorName" align="center" label="创建人"/>-->
        <!--        <el-table-column prop="createTime" align="center" label="创建时间"/>-->
        <el-table-column prop="submitTime" align="center" label="提交时间"/>
        <el-table-column prop="note" align="center" label="备注"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="120px">
          <template slot-scope="scope">
            <!--            <el-button v-if="editAuth" type="primary" :disabled="scope.row.status===20" @click="$refs.editPage.open(scope.row.pkid)">编辑</el-button>-->
            <!--            <el-button v-if="delAuth" type="danger" :disabled="scope.row.status===20" @click="deleteRow(scope.row)">删除</el-button>-->
            <el-button v-if="scope.row.creatorId === currentId" type="primary" :disabled="!scope.row.status===0" @click="$refs.editPage.open(scope.row.pkid)">编辑</el-button>
            <el-button v-if="scope.row.status===0 && scope.row.creatorId === currentId" type="primary" @click="submit(scope.row.pkid)">提交</el-button>
            <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </vm-table>
      <p-u-i-edit ref="editPage" @save-success="getList(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import PUIEdit from "@/views/afterSalesManagement/PUI/PUIEdit";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "PUI",
    components: {PUIEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        // addAuth: this.$auth(252),
        // editAuth: this.$auth(253),
        // delAuth: this.$auth(254),
        currentId: loginUtil.getUserId(),
        ids: [],
        filter: {
          puiNo: "",
          applyType:"",
          productName: "",
          productModel: "",
          versionNo: "",
          status: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      submit(pkid) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", "pui/submit/" + pkid).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      select(selection) {
        this.ids = [];
        for (let item of selection) {
          this.ids.push(item.pkid);
        }
      },
      deleteRow(row) {
        this.ids = [];
        this.ids.push(row.pkid);
        this.deleteRows();
      },
      clipboardSuccessHandler(e) {
        this.$message.success("复制单号成功");
      },
      clipboardErrorHandler(e) {
        this.$message.error("复制单号失败");
      },
      goto(row) {
        this.$router.push({
          path: "/PUI",
          query: {
            billType: 31,
            billId: row.pkid,
            $tabName: row.billNo,
          },
        });
      },
      deleteRows() {
        if (this.ids.length == 0) {
          this.$message.error("请先选择删除项");
          return;
        }
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "pui", this.ids)
            .then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        });
      },
    },
  };
</script>
<style scoped>
</style>
